var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7831 24.1942C44.4463 23.531 45.5175 23.531 46.1807 24.1942L46.1977 24.1772C46.8608 24.8403 46.8608 25.9115 46.1977 26.5747L37.6475 35.1249L46.1805 43.6579C46.8436 44.3211 46.8436 45.3923 46.1805 46.0554L46.1975 46.0724C45.5344 46.7356 44.4631 46.7356 43.8 46.0724L35.2499 37.5224L26.7 46.0724C26.0379 46.7344 24.9645 46.7344 24.3024 46.0724C23.6404 45.4103 23.6404 44.3369 24.3024 43.6749L32.8524 35.1249L24.3023 26.5747C23.6402 25.9127 23.6402 24.8393 24.3023 24.1772C24.9643 23.5152 26.0377 23.5152 26.6998 24.1772L35.2499 32.7274L43.7831 24.1942Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.25 35.125C70.25 54.455 54.58 70.125 35.25 70.125C15.92 70.125 0.25 54.455 0.25 35.125C0.25 15.795 15.92 0.125 35.25 0.125C54.58 0.125 70.25 15.795 70.25 35.125ZM68.25 35.125C68.25 53.3504 53.4754 68.125 35.25 68.125C17.0246 68.125 2.25 53.3504 2.25 35.125C2.25 16.8996 17.0246 2.125 35.25 2.125C53.4754 2.125 68.25 16.8996 68.25 35.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4a596c9746632de642f8032bf4b7afe8.svg";
export { ForwardRef as ReactComponent };